import { AfterViewInit, ElementRef, Directive, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { combineLatest, timer } from 'rxjs';
import { GearsAnimationStatus } from '../../shared/gearsanimation';
import { validateExcludeAgbs } from '../../shared/utils';
import { scrollInvalidControl } from '../../shared/scroll';
import { delay, first } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { PopupService } from '../service/popup.service';

@Directive({
  selector: '[appStepperLinearInitFutureStep]'
})
export class StepperLinearInitFutureStepDirective implements OnInit, AfterViewInit {

  @Input()
  selectIndex: number;

  stepSelected = false;

  dueTime = 30000;

  constructor(private el: ElementRef, private host: MatStepper, private gearsAnimationStatus: GearsAnimationStatus,
    public translateService: TranslateService, public popupService: PopupService) { }

  ngOnInit() {
    if (this.selectIndex === null) {
      return;
    }
    Promise.resolve().then(() => this.gearsAnimationStatus.setGearsAnimation(true));
    this.host.animationDone.pipe(first()).toPromise().then(() => {
      timer(this.dueTime).subscribe(() => {
        const controlsLeft = this.host.steps.toArray()
          .slice(0, this.leftIndex)
          .map(x => x.stepControl as UntypedFormGroup);
        for (let i = 0; i < controlsLeft.length; i++) {
          if (!this.host.steps.toArray()[i].optional && !validateExcludeAgbs(controlsLeft[i])) {
            if (this.host.selectedIndex !== i) {
              this.host.animationDone.pipe(first()).toPromise().then(() => {
                this.stopGearsAnimationTabpanelScrollInvalidControl(i);
              });
              this.host.selectedIndex = i;
            } else {
              this.stopGearsAnimationTabpanelScrollInvalidControl(i);
            }
            return;
          }
        }
      });
    });
  }

  ngAfterViewInit() {
    if (this.selectIndex === null) {
      return;
    }
    this.host.steps.toArray()
      .slice(0, this.leftIndex)
      .filter(x => !x.optional).forEach((element) => {
        element.interacted = true;
    });
    const controlsLeft = this.host.steps.toArray()
      .slice(0, this.leftIndex)
      .filter(x => !x.optional)
      .map(x => x.stepControl as UntypedFormGroup);
    combineLatest(
      controlsLeft.map(x => x.valueChanges)
    ).subscribe(() => {
      if (!this.stepSelected) {
        if (validateExcludeAgbs(new UntypedFormArray(controlsLeft))) {
          this.host.linear = false;
          this.host.selectedIndex = this.selectIndex;
          this.host.linear = true;
          this.stepSelected = true;
          this.gearsAnimationStatus.setGearsAnimation(false);
        }
      }
    });
  }

  get leftIndex() {
    return this.selectIndex + 1 < this.host.steps.length ? this.selectIndex + 1 : this.selectIndex;
  }

  tabpanelScrollInvalidControl(selectedIndex: number) {
    const control = this.el.nativeElement.querySelectorAll('div[role="tabpanel"]')[selectedIndex];
    scrollInvalidControl(control);
  }

  stopGearsAnimationTabpanelScrollInvalidControl(selectedIndex: number) {
    this.gearsAnimationStatus.getGearsAnimation().pipe(first(), delay(300)).toPromise().then(() => {
      this.tabpanelScrollInvalidControl(selectedIndex);
      this.translateService.get('ANTRAGERSTELLUNGNEUBERECHNUNGINFO')
        .subscribe((text) => {
          this.popupService.openInfoPopup(text);
        });
      this.stepSelected = true;
    });
    this.gearsAnimationStatus.setGearsAnimation(false);
  }
}
